module.exports = __webpack_public_path__ + "static/media/vignesh.9bb359af.png";